import {
  LOAD_DASHBOARD_DETAILS,
  LOAD_DASHBOARD_GRAPH_DETAILS
} from "../../common/constants";

export const loadDashboardDetails = dashboardinfo => {
  return { type: LOAD_DASHBOARD_DETAILS, dashboardinfo };
};

export const loadDashboardGraphDetails = graphInput => {
  return { type: LOAD_DASHBOARD_GRAPH_DETAILS, graphInput };
};



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/actions.js